// @core/api/endpoints/task/add_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddDependencyRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Add dependency
 * Creates a dependency relationship between tasks. Supports various dependency types like blocks, is-blocked-by, and relates-to.
 */
export async function AddDependency(
  task_id: string,
  data: AddDependencyRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/dependencies`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
